// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"0c07e5f5","101":"7d5de21d","269":"e8fd39c1","357":"7c5874fb","447":"8525b45c","549":"f482a550","723":"245e1142","730":"e9dd7645","731":"bc6d669c","845":"c1de3ef8"}[chunkId] + ".chunk.js";
};